export const SORT_MENU_PACHI = [
    {
      id: 0,
      name: '納品開始日',
      key: 'nohinkaishibi'
    },
    {
      id: 1,
      name: 'アウト',
      key: 'out'
    },
    {
      id: 2,
      name: '台売上',
      key: 'uriage'
    },
    {
      id: 3,
      name: '台粗利',
      key: 'arari'
    },
    {
      id: 4,
      name: '玉単価',
      key: 'tama_tanka'
    },
    {
      id: 5,
      name: '玉粗利',
      key: 'tama_arari'
    },
    {
      id: 6,
      name: '中古価格',
      key: 'used_machine_price'
    },
    {
      id: 7,
      name: '増減',
      key: 'zogen_used_machine_price'
    },
    {
      id: 8,
      name: '平均設置台数',
      key: 'display_heikin_daisu'
    },
    {
      id: 9,
      name: 'スタート',
      key: 'start'
    },
    {
      id: 10,
      name: 'S1',
      key: 'S1'
    },
    {
      id: 11,
      name: 'ベース',
      key: 'base'
    },
    {
      id: 12,
      name: 'BY',
      key: 'BY'
    },
    {
      id: 13,
      name: 'BYmin',
      key: 'BYmin'
    },
    {
      id: 14,
      name: 'T1Y',
      key: 'T1Y'
    },
    {
      id: 15,
      name: 'TY',
      key: 'TY'
    },
    {
      id: 16,
      name: '250玉スタート',
      key: '250tama_start'
    },
    {
      id: 17,
      name: '初当確率',
      key: 'TS'
    },
    {
      id: 18,
      name: 'SA',
      key: 'SA'
    },
    {
      id: 19,
      name: 'BA',
      key: 'BA'
    },
    {
      id: 20,
      name: 'TO',
      key: 'TO'
    },
    {
      id: 21,
      name: 'T1O',
      key: 'T1O'
    },
    {
      id: 22,
      name: '客滞率',
      key: 'kyakutai_ritsu'
    },
    {
      id: 23,
      name: 'メーカー',
      key: 'brand_display_name'
    },
    {
      id: 24,
      name: 'タイプ',
      key: 'type_display_name'
    },
    {
      id: 25,
      name: '設置台数',
      key: 'display_total_daisu'
    }
  ];
  
  export const SORT_MENU_SLOT = [
    {
      id: 0,
      name: '納品開始日',
      key: 'nohinkaishibi'
    },
    {
      id: 1,
      name: 'アウト',
      key: 'out'
    },
    {
      id: 2,
      name: '台売上',
      key: 'uriage'
    },
    {
      id: 3,
      name: '台粗利',
      key: 'arari'
    },
    {
      id: 4,
      name: 'メダル単価',
      key: 'tama_tanka'
    },
    {
      id: 5,
      name: 'メダル粗利',
      key: 'tama_arari'
    },
    {
      id: 6,
      name: '中古価格',
      key: 'used_machine_price'
    },
    {
      id: 7,
      name: '増減',
      key: 'zogen_used_machine_price'
    },
    {
      id: 8,
      name: '平均設置台数',
      key: 'display_heikin_daisu'
    },
    {
      id: 9,
      name: '平均段階設定',
      key: 'heikin_dankai_settei'
    },
    {
      id: 10,
      name: '出玉率',
      key: 'dedama_ritsu'
    },
    {
      id: 11,
      name: '50枚G数',
      key: 'game_50mai'
    },
    {
      id: 12,
      name: 'TY',
      key: 'TY'
    },
    {
      id: 13,
      name: '最大出玉数',
      key: 'saidai_dedamasu'
    },
    {
      id: 14,
      name: '最大吸込数',
      key: 'saidai_suikomisu'
    },
    {
      id: 15,
      name: '客滞率',
      key: 'kyakutai_ritsu'
    },
    {
      id: 16,
      name: 'メーカー',
      key: 'brand_display_name'
    },
    {
      id: 17,
      name: 'タイプ',
      key: 'type_display_name'
    },
    {
      id: 18,
      name: '設置台数',
      key: 'display_total_daisu'
    }
  ];